const SvgConsultSubmit = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_18325_413)">
        <path
          d="M3.9375 3C2.59802 3 1.5 4.09802 1.5 5.4375V12.5625C1.5 13.902 2.59802 15 3.9375 15H14.0625C15.402 15 16.5 13.902 16.5 12.5625V5.4375C16.5 4.09802 15.402 3 14.0625 3H3.9375ZM3.9375 4.125H14.0625C14.7938 4.125 15.375 4.70623 15.375 5.4375V5.85205L9 9.2981L2.625 5.85205V5.4375C2.625 4.70623 3.20623 4.125 3.9375 4.125ZM2.625 7.13086L8.73267 10.4326C8.81479 10.477 8.90666 10.5002 9 10.5002C9.09334 10.5002 9.18521 10.477 9.26733 10.4326L15.375 7.13086V12.5625C15.375 13.2938 14.7938 13.875 14.0625 13.875H3.9375C3.20623 13.875 2.625 13.2938 2.625 12.5625V7.13086Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_18325_413">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgConsultSubmit;
